export const notNull = (x) => x !== null;
export const notUndefined = (x) => x !== undefined;
export const notNullUndefined = (x) => x !== null && x !== undefined;
export const isEmptyString = (x) => x === "" ? true : false;